import React from "react";
import { fontSizes } from "@/constants/constants";
import HeroLeadForm from "./hero-lead-form";

const CheckIcon = () => (
  <svg className="mt-0.5 shrink-0" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <circle cx="10" cy="10" r="10" fill="#61C1E5" />
    <path d="M6 10.5l2.5 2.5L14 7.5" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const defaultHighlights = [
  "100% original, plagiarism-free work",
  "Dedicated project manager",
  "Unlimited revisions until you're happy",
  "On-time delivery, every time",
];

const BookWritingHero = ({
  title,
  subtitle,
  description,
  formLabel,
  highlights = defaultHighlights,
  form,
}) => {
  return (
    <section className="relative w-full overflow-hidden bg-paper bg-paper-grain">
      {/* decorative glows */}
      <div aria-hidden className="pointer-events-none absolute -left-24 top-20 h-72 w-72 rounded-full bg-brand-200/25 blur-3xl" />
      <div aria-hidden className="pointer-events-none absolute -right-16 top-40 h-72 w-72 rounded-full bg-gold-soft/20 blur-3xl" />

      <div className="relative mx-auto flex w-full max-w-[1350px] flex-col items-center px-5 pt-10 pb-10 md:pt-16">
        <div className="grid w-full grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
          {/* Left — content */}
          <div className="flex flex-col items-start text-left max-lg:items-center max-lg:text-center">
            <span className="eyebrow flex items-center gap-3 text-gold-deep">
              <span className="h-px w-8 bg-gold/70" />
              {title}
            </span>

            <h1 className={`mt-5 font-display font-semibold capitalize text-ink ${fontSizes.text_6_xl}`}>
              {subtitle}
            </h1>

            <p className={`mt-5 leading-relaxed text-ink-soft ${fontSizes.base}`}>
              {description}
            </p>

            {highlights?.length > 0 && (
              <ul className="mt-7 grid w-full max-w-xl grid-cols-1 gap-x-6 gap-y-3 sm:grid-cols-2 max-lg:justify-items-start">
                {highlights.map((item, index) => (
                  <li key={index} className="flex items-start gap-2.5">
                    <CheckIcon />
                    <span className={`text-ink ${fontSizes.base}`}>{item}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* Right — form */}
          <div className="flex w-full justify-center lg:justify-end">
            <HeroLeadForm formLabel={formLabel || `${title || "Service"} — Hero Form`} {...form} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookWritingHero;
